import React from 'react'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import withStyles from '@material-ui/core/styles/withStyles'

const styles = (theme) => ({
  header: {
    color: '#fff',
    textTransform: 'uppercase',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1em',
    },
  },
})

const Section = ({ classes, innerSections, ...props }) => (
  <Grid {...props} xs={12} sm={4} item>
    {innerSections.map(({ header, body }, i) => (
      <div key={`inner_section${i}`}>
        <Typography className={classes.header} variant="title" gutterBottom>
          {header}
        </Typography>
        {body}
      </div>
    ))}
  </Grid>
)

Section.propTypes = {
  classes: PropTypes.object.isRequired,
  innerSections: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      body: PropTypes.node.isRequired,
    }),
  ).isRequired,
}

export default withStyles(styles)(Section)



// WEBPACK FOOTER //
// ./src/components/Footer/Section.js